import { encryptionKeys } from "./constants";
import CryptoJS from "crypto-js";

export const setLocalStorageItem = (key: string, value: string) => {
  const encryptedData = CryptoJS.AES.encrypt(
    value,
    encryptionKeys.localStorage
  ).toString();
  localStorage.setItem(key, encryptedData);
};

export const getLocalStorageItem = (key: string) => {
  const storedValue = localStorage.getItem(key);
  if (!storedValue) {
    return "";
  }
  try {
    const bytes = CryptoJS.AES.decrypt(
      storedValue,
      encryptionKeys.localStorage
    );
    const originalText = bytes.toString(CryptoJS.enc.Utf8);

    if (!originalText) {
      return "";
    }
    return key === "accessToken" ? originalText : JSON.parse(originalText);
  } catch (error) {
    console.error("Decryption error:", error);
    return "";
  }
};

export const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};
